import definePlan from './define-plan.json';
import video from './video.json';
import contributions from './contributions.json';
import inflationInfo from './inflation-info.json';
import summary from './summary.json';

export default {
  'retirement-fund': {
    ...definePlan,
    ...video,
    ...contributions,
    ...summary,
    ...inflationInfo,
  },
};
